export const SONG_KEYS = ['C', 'C#', 'D', 'Eb', 'E', 'F', 'F#', 'G', 'Ab', 'A', 'Bb', 'B'] as const;

/** "Never", "Today", "Nov 1", "Dec 24, 2025" */
export const lastPlayedLabel = (date?: string, now = new Date()): string => {
  if (!date) return 'Never';
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return 'Never';
  const sameDay = d.toDateString() === now.toDateString();
  if (sameDay) return 'Today';
  return d.toLocaleDateString('en-US', d.getFullYear() === now.getFullYear() ? { month: 'short', day: 'numeric' } : { month: 'short', day: 'numeric', year: 'numeric' });
};

export interface SongFormData {
  title: string;
  artist: string;
  key: string;
  tempo: string;
  ccliNumber: string;
  youtubeUrl: string;
  lastPlayed: string;
}

export const EMPTY_SONG_FORM: SongFormData = {
  title: '',
  artist: '',
  key: 'C',
  tempo: '120',
  ccliNumber: '',
  youtubeUrl: '',
  lastPlayed: '',
};
